export const AgisticsColors = {
    lightGray: '#e4e4e4',
    lightGray2: '#d4d4d4',
};

export const HereMapColors = {
    ACTIVE: '#00FF00',
    AVOIDANCE_ZONE: '#FF0000',
    CALCULATED_ROUTE: '#0080FF',
    DEACTIVATED_AVOIDANCE_ZONE: '#CACACA',
    DEACTIVATED_GLOBAL_AVOIDANCE_ZONE: '#FFFFFF',
    GLOBAL_AVOIDANCE_ZONE: '#FA8800',
    HIGHLIGHTED_ROUTE: '#FFE600',
    INACTIVE: '#6300A6',
    LOCATION_DEFAULT_STROKE: '#0080FF',
    SMART_TRAILER: '#2AEEFF',
    STANDARD_ROUTE: '#FA8800',
};

export const LocationColors = {
    BLACK: '#000000',
    CYAN: '#2AEEFF',
    GREEN: '#009E73',
    LAVENDER: '#B266FF',
    LIME_GREEN: '#00FF00',
    PINK: '#FF83C9',
    PURPLE: '#6300A6',
    YELLOW: '#FFE600',
}

export const EntityColors = {
    BLUE: '#0080FF',
    CYAN: '#2AEEFF',
    LIME_GREEN: '#00FF00',
    ORANGE: '#FA8800',
    PURPLE: '#6300A6',
    YELLOW: '#FFE600',
    RED: '#FF0000',
    BLACK: '#000000',
    GRAY: '#808080',
    GREEN: '#008000',
    PINK: '#E56DB1',
};